import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { id: "side-bar" }, null, -1)
const _hoisted_2 = { class: "content-view" }

import { inject, onMounted, onUnmounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import Bar from "./component/Bar.vue";
import SideMenu from "./component/SideMenu.vue";
import { RunnerNavigationBridge, startRunnerNavigation } from "./domain/RunnerNavigation";


export default /*#__PURE__*/_defineComponent({
  props: {
	authService: {
		type: Object,
	}
},
  setup(__props) {



const session = inject("session") as any;
const route = useRoute();
const menuVersion = session && session.user ? session.user.menuVersion : undefined;
const shouldRenderPersistentSideMenu = menuVersion === 'sidebar';
let runnerNavigationBridge: RunnerNavigationBridge;

const stopRouteWatcher = watch(() => route.fullPath, function () {
	if (runnerNavigationBridge) runnerNavigationBridge.notify();
});

onMounted(() => {
	const i18n = inject('i18n') as any;
	if (i18n) {
		i18n.locale = 'pt';
	}

	if (shouldRenderPersistentSideMenu) runnerNavigationBridge = startRunnerNavigation(window);
});

onUnmounted(() => {
	stopRouteWatcher();
	if (runnerNavigationBridge) runnerNavigationBridge.stop();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["main-view", { 'persistent-side-menu-layout': shouldRenderPersistentSideMenu }])
    }, [
      _hoisted_1,
      shouldRenderPersistentSideMenu
        ? (_openBlock(), _createBlock(SideMenu, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Bar, { authService: __props.authService }, null, 8, ["authService"]),
        _createVNode(_component_router_view)
      ])
    ], 2)
  ]))
}
}

})